module.exports = __webpack_public_path__ + "img/experience-5-image.856d8ceb.jpg";